import type {
  AutoRefillResponse,
  AutoRefillSettings,
} from "@server/types/autoRefillTypes";
import { createOrgApiUrl } from "@/utils/apiUtils";
import { fetchWithAuth } from "@/utils/fetch";

/** Organization-scoped cache for refill settings and operational status. */
export const autoRefillQueryKey = (orgId: string) =>
  ["billing", orgId, "auto-refill"] as const;

/** Admin-owned settings and operational status; purchase history uses the purchases endpoint. */
export async function fetchAutoRefill(orgId: string) {
  return (
    await fetchWithAuth<AutoRefillResponse>(
      createOrgApiUrl(orgId, "billing", "auto-refill"),
      { preserveErrorBody: true },
    )
  ).data;
}
/** Explicit customer consent or disable; the server validates the current catalog revision. */
export async function saveAutoRefill(
  orgId: string,
  input:
    | { enabled: false }
    | (AutoRefillSettings & { catalog_revision: number }),
) {
  await fetchWithAuth(createOrgApiUrl(orgId, "billing", "auto-refill"), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
    preserveErrorBody: true,
  });
}
